import React from "react"
import { Steps } from "../journey/step-library"
import { H2, Container, FlexContainer } from "@carrotfertility/carotene"
import ArrowSubmitButton from "components/carrot-plans/shared/ArrowSubmitButton"
import { useMedicalInfo } from "../../context/MedicalInfoContext"
import { Skip } from "../../../views/fle/Molecules"
import { useStateMachine } from "../../../context/stateMachine/StateMachineContext"
import { useJourneyFlow } from "../../shared/JourneyFlowContainer"
import useButtonSingleSelect from "../../hooks/useButtonSingleSelect"
import ButtonSelectGroup from "../../shared/ButtonSelectGroup"

const step = Steps.PERIODS_PAINFUL
export default function PeriodsPainfulStep(): JSX.Element {
  const title = "Are your periods so painful that they make you miss work or activities?"
  const { medicalInfo, updateMedicalInfo, hasQuestionBeenSkipped } = useMedicalInfo()
  const defaultValue = medicalInfo?.periodsPainful

  const { handleContinueLoading, continueLoading } = useJourneyFlow()
  const { setNextStep } = useStateMachine(step, hasQuestionBeenSkipped(step) ? "" : defaultValue)

  const { valid, ...buttonProps } = useButtonSingleSelect({
    options: [
      { title: "Yes", id: "YES" },
      { title: "No", id: "NO" }
    ],
    defaultValue: defaultValue,
    onSubmit: onClickContinue
  })

  async function onClickContinue(selectedValue: string): Promise<void> {
    if (selectedValue !== null) {
      await handleContinueLoading(() => updateMedicalInfo({ periodsPainful: selectedValue }))
      setNextStep(step, selectedValue)
    }
  }

  async function onSkip(): Promise<void> {
    await handleContinueLoading(() => updateMedicalInfo({ skipFields: [step] }))
    setNextStep(step, "")
  }

  return (
    <form
      onSubmit={(event) => {
        event.preventDefault()
        onClickContinue(defaultValue)
      }}
    >
      <Container stack="large">
        <H2 stack="tiny">{title}</H2>
      </Container>
      <Container>
        <ButtonSelectGroup {...buttonProps} />
      </Container>
      <FlexContainer paddingTopBottom="huge" justifyContent="space-between">
        <Skip onClick={onSkip} onClickOnly enabled={!continueLoading} />
        <ArrowSubmitButton enabled={valid && !continueLoading}>Continue</ArrowSubmitButton>
      </FlexContainer>
    </form>
  )
}
